<template>
    <div class="page-content conmon-top">
        <div class="base-input ovf-hd" style="margin-bottom: 10px;">
            <el-row class="search-content common-search-formtype el-row" style="line-height: 25px;padding-bottom: 16px">
                <div class="orderTop1">
                    <div class="order-title">
                        订单信息
                    </div>
                    <div class="order-type">
                        <el-col :span="8" v-if="detailInfo.orderNo !=='' && detailInfo.orderNo!=null">
                            订单编号：{{detailInfo.orderNo}}
                        </el-col>
                        <el-col :span="8" v-if="detailInfo.createTime !=='' && detailInfo.createTime!=null">创建时间：{{detailInfo.createTime}} </el-col>
                        <el-col :span="8" v-if="detailInfo.orderStatus !=='' && detailInfo.orderStatus!=null">订单状态：
                            <span v-if="detailInfo.orderStatus ==='unpaid'">未支付</span>
                            <span v-if="detailInfo.orderStatus ==='wait_group'">待成团</span>
                            <span v-if="detailInfo.orderStatus ==='wait_deliver'">待发货</span>
                            <span v-if="detailInfo.orderStatus ==='wait_receive'">已发货</span>
                            <span v-if="detailInfo.orderStatus ==='unverified'">未核销</span>
                            <span v-if="detailInfo.orderStatus ==='verified'">已核销</span>
                            <span v-if="detailInfo.orderStatus ==='closed'">已关闭</span>
                            <span v-if="detailInfo.orderStatus ==='completed'">已完成</span>
                            <span v-if="detailInfo.orderStatus ==='group_failed'">拼团失败</span>
                            <span v-if="detailInfo.orderStatus ==='refunded'">已退款</span>
                            <span v-if="detailInfo.orderStatus ==='refund_failed'">退款失败</span>
                            <span v-if="detailInfo.orderStatus ==='refunding'">退款中</span>
                        </el-col>
                        <el-col :span="8" v-if="detailInfo.orderSourceSystem!=='' && detailInfo.orderSourceSystem!=null ">
                            订单来源：{{detailInfo.orderSourceSystem === 'ZY_GROUP'? '云团':(detailInfo.orderSourceSystem === 'CLOUD_SHOP'? '云店': (detailInfo.orderSourceSystem === 'ZY_MEMBER'?'云众':''))}}
                        </el-col>
                        <el-col :span="8" v-if="detailInfo.orderAmntDes!=='' && detailInfo.orderAmntDes!=null">
                            订单金额：{{detailInfo.orderAmntDes}}</el-col>
                        <el-col :span="8" v-if="detailInfo.orderGoodsNum!=='' && detailInfo.orderGoodsNum!=null">订单商品数量：{{detailInfo.orderGoodsNum}}</el-col>
                        <el-col :span="8" v-if="detailInfo.orderType!=='' && detailInfo.orderType!=null">
                            订单类型：{{detailInfo.orderType ==1?'拼团订单': (detailInfo.orderType ==2?'线下订单': (detailInfo.orderType ==3?'积分订单':(detailInfo.orderType ==4?'团购订单':(detailInfo.orderType ==5?'直播订单':(detailInfo.orderType ==6?'秒杀': (detailInfo.orderType ==7?'阶梯拼团':''))))))}}
                        </el-col>
                        <el-col :span="8" v-if="detailInfo.payType!=='' && detailInfo.orderType!=null"> 支付方式：{{detailInfo.payType==1?'微信支付':(detailInfo.payType==2?'银行转账':(detailInfo.payType==3?'货到付款':(detailInfo.payType==4?'积分':(detailInfo.payType==5?'积分+现金支付':''))))}}</el-col>
                        <el-col :span="8" v-if="detailInfo.payTime!=='' && detailInfo.payTime!=null">支付时间：{{detailInfo.payTime}}</el-col>
                        <el-col :span="8" v-if="detailInfo.payNo!=='' && detailInfo.payNo!=null">
                            支付单号：{{detailInfo.payNo}}
                        </el-col>
                        <el-col :span="8" v-if="detailInfo.receivedTime!=='' && detailInfo.receivedTime!=null ">
                            收货时间：{{detailInfo.receivedTime}}
                        </el-col>
                        <el-col :span="8" v-if="detailInfo.updateTime!=='' && detailInfo.updateTime!=null"> 更新时间： {{detailInfo.updateTime}}</el-col>
                        <el-col :span="8" v-if="detailInfo.remark!=='' && detailInfo.remark!=null">订单备注：{{detailInfo.remark}}</el-col>
                        <el-col :span="8" v-if="detailInfo.orderGroupNo!=='' && detailInfo.orderGroupNo!=null">
                            开团编号：{{detailInfo.orderGroupNo}}
                        </el-col>
                        <el-col :span="8" v-if="detailInfo.groupFailTime!=='' && detailInfo.groupFailTime!=null"> 拼团失败时间：{{detailInfo.groupFailTime}}</el-col>
                        <el-col :span="8"></el-col>
                        <el-col :span="8" v-if="detailInfo.applyRefundTime!=='' && detailInfo.applyRefundTime!=null">
                            申请退款时间：{{detailInfo.applyRefundTime}}
                        </el-col>
                        <el-col :span="8" v-if="detailInfo.refundedTime!=='' && detailInfo.refundedTime!=null"> 退款时间：{{detailInfo.refundedTime}} </el-col>
                        <el-col :span="8" v-if="detailInfo.giftName!=='' && detailInfo.giftName!=null">赠品：{{detailInfo.giftName}}</el-col>
                    </div>
                </div>
            </el-row>
            <el-row class="search-content common-search-formtype el-row" style="line-height: 25px;padding: 10px">
                <div>
                    <el-col :span="8">
                        <div class="orderManageInfo" :class="detailInfo.orderSourceSystem==='ZY_GROUP'?'orderManageInfo1':'orderManageInfo2'">
                        <div class="order-title1">
                            买家信息
                        </div>
                        <div class="order-cont1">
                            <div>买家头像/昵称：<span v-if="detailInfo.headImg!=='' && detailInfo.headImg!=null">
                                <img style="width: 30px;height: 30px;border-radius: 50%" :src="detailInfo.headImg">/ </span>{{detailInfo.nickname}}</div>
                            <div>openid： {{detailInfo.openid}}</div>
                            <div>unionid：{{detailInfo.unionid}}</div>
                            <div v-if="detailInfo.orderSourceSystem==='ZY_GROUP'">
                            <div>买家名称：{{detailInfo.buyerName}}</div>
                            <div>买家手机号：{{detailInfo.buyerMobile}}</div>
                            <div>买家身份：{{detailInfo.buyerIdentity}}</div>
                            <div>买家上级：{{detailInfo.buyerUp}}</div>
                            <div>团购商:{{detailInfo.tgsName}}</div>
                            <div>是否代下单：{{detailInfo.isSubstitute ==1?'不是':(detailInfo.isSubstitute ==2?'是':'')}}</div>
                            </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="orderManageInfo" :class="detailInfo.orderSourceSystem==='ZY_GROUP'?'orderManageInfo1':'orderManageInfo2'">
                        <div class="order-title1">
                            收货人信息
                        </div>
                            <div class="order-cont1">
                                <div>联系人：{{detailInfo.receiverName}}</div>
                                <div>手机号：{{detailInfo.receiverMobile}}</div>
                                <div>收货地址：{{detailInfo.receiverAddress}}</div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="orderManageInfo" :class="detailInfo.orderSourceSystem==='ZY_GROUP'?'orderManageInfo1':'orderManageInfo2'">
                        <div class="order-title1">
                            配送信息
                        </div>
                            <div class="order-cont1">
                                <div>配送方式：{{detailInfo.receiveType==1?'自提':(detailInfo.receiveType==2?'邮寄':(detailInfo.receiveType==3?'自动发放':(detailInfo.receiveType==4?'线下配送':'')))}}</div>
                                <div>快递公司：{{detailInfo.expressName}}</div>
                                <div>发货单号：{{detailInfo.expressNo}}</div>
                                <div>发货时间：{{detailInfo.sendTime}}</div>
                            </div>
                        </div>
                    </el-col>
                </div>
            </el-row>
            <el-row class="search-content common-search-formtype el-row" style="margin-top: 15px;line-height: 35px">
                <el-table
                        class="order-list-table"
                        :data="tableData"
                        border
                        style="margin-top: 15px;border-top: 1px solid #e2e3e3"
                >
                    <template slot="empty">
                        <div class="newTableEmpty">没有更多数据了</div>
                    </template>
                    <el-table-column
                        label="产品名称"
                        prop="goodsName"
                ></el-table-column>
                    <el-table-column
                            label="原价"
                            prop="goodsOriginalPrice"
                    >  <template slot-scope="scope">
                        {{scope.row.goodsOriginalPrice}}
                    </template></el-table-column>
<!--                    <el-table-column-->
<!--                            label="销售价"-->
<!--                            prop="goodsPrice"-->
<!--                    ></el-table-column>-->
                    <el-table-column
                            label="数量"
                            prop="quantity"
                    ></el-table-column>
                    <el-table-column
                            v-if="detailInfo.orderType ==3"
                            label="支付积分"
                            prop="goodsIntegral"
                    ></el-table-column>
                    <el-table-column
                            label="支付金额"
                            prop="goodsPrice"
                    ></el-table-column>
<!--                    <el-table-column-->
<!--                            label="小计"-->
<!--                            prop="totalPrize"-->
<!--                    ></el-table-column>-->
                </el-table>
                <div class="countMoney">
                    <div><span></span><span>运费：{{detailInfo.expressPrice}}元</span></div>
                    <div><span></span><span>订单金额：{{detailInfo.orderAmntDes}}</span></div>
                    <div><span></span><span>优惠金额：<span v-if="detailInfo.orderDisctAmnt!=0 && detailInfo.orderDisctAmnt!=null && detailInfo.orderDisctAmnt !=''">-</span>
                        {{detailInfo.orderDisctAmnt==''? 0 : (detailInfo.orderDisctAmnt === null? 0: detailInfo.orderDisctAmnt )}}元</span></div>
                    <div><span></span><span>实付金额：{{detailInfo.orderPayDes}}</span></div>
                </div>
            </el-row>
        </div>
    </div>
</template>

<script>
import { getOrderList, getOrderDetail } from '@/api/analyse.js'
import TemplateMessage from '../weixin-manage/template-message'
export default {
  name: 'order-manage-detail',
  components: { TemplateMessage },
  data() {
    return {
      tableData: [],
      detailInfo: {}
    }
  },
  methods: {
    getDetailWay (id) {
      getOrderDetail(id).then(res => {
        console.log(res, 'res')
        if(res.data.code === 200 || res.data.code === '200') {
          let goodsList = res.data.result.goodsList
          res.data.result.giftName = ''
          goodsList.map(function(it, ind){
            if(it.gift == 1) {
              res.data.result.giftName = it.goodsName
            }
          })
          this.detailInfo = res.data.result
          this.tableData = res.data.result.goodsList
        } else {
          this.detailInfo = {}
          this.tableData = []
        }
      })
    }
  },
  created() {
    this.getDetailWay(this.$route.query.orderId)
  }
};
</script>

<style scoped>

    .countMoney {
        padding: 20px;
    }
    .countMoney >div {
        display: flex;
        line-height: 40px;
        justify-content: space-between;
    }
    .order-cont1 >div{
        font-size: 14px;
        text-align: left;
    }
    .orderManageInfo {
        padding: 10px;
        border: 1px solid #e2e3e3;
        margin: 20px;
    }
    .orderManageInfo1{
         height: 280px;
     }
    .orderManageInfo2{
        height: 160px;
    }
    .orderTop1 {
        margin: 20px 30px;
    }
    .search-content {
        margin-bottom: 15px;
    }
    .order-title1 {
        font-size: 16px;
        padding-bottom: 10px;
        font-weight: bold;
        text-align: left;
    }
.order-title {
    border-bottom: 1px solid #999999;
    text-align: left;
    font-size: 16px;
    padding-bottom: 15px;
    font-weight: bold;
    margin-bottom: 15px;
}

    .order-type {
        text-align: left;
    }
</style>
